import React, { FunctionComponent } from "react";

export const RequireNewPasswordForm: FunctionComponent = () => (
  <div>RequireNewPasswordForm</div>
);
